export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  UPLOAD_ERROR = 'upload_error',
  UPLOAD_SUCCESS = 'upload_success',
  INVALID_FILE = 'invalid_file',
}
